<template>
  <div class="mt-5">
    <orcamento-cadastro v-if="modoCadastro"
                        @selecionarOrcamento="tratarEventoAcessarOrcamento"
                        @cancelarCadastro="cancelarModoCadastro"/>
    <orcamento-edicao v-if="modoEdicao"
                      :orcamentoSelecionado="orcamentoSelecionado"
                      @cancelarEdicao="cancelarModoEdicao"/>
    <div v-if="!modoCadastro && !modoEdicao">
      <div class="container-pesquisa-orcamentos">
        <v-btn color="primary" class="text-transform-none" depressed @click="adicionarOrcamento">
          <v-icon>mdi-plus</v-icon>
          Adicionar orçamento
        </v-btn>
        <pesquisa-avancada
            :filter="filtrosInterno"
            @remove-filter="tratarEventoRemoverFiltro"
            @simple-search="tratarEventoBuscaSimples"
            :maxlengthInput="maxInputPesquisa"
            simple-search-placeholder="Busque por código..."/>
      </div>

      <div class="container-tabela-orcamentos">
        <paciente-ficha-orcamento-tabela
            :itens="itens"
            :paginas="paginas"
            :total-itens="totalItens"
            :paginacao="$store.state.orcamento.resultadoBuscaTodosOrcamentosFicha.paginacao"
            @acessar="tratarEventoAcessarOrcamento"
        />
      </div>

      <div class="pl-2 pr-3">
        <div class="pagination">
          <v-pagination
              v-if="paginas > 1"
              v-model="paginacaoInterna.page"
              total-visible="7"
              :length="paginas"
              @input="tratarEventoPaginar"
          />
          <v-spacer v-if="paginas <= 1"/>
          <div class="select-pagination">
            <span>Linhas por página:</span>
            <v-select :items="linhasPorPagina" @change="resetarPaginacao" v-model="paginacaoInterna.size"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import {actionTypes, mutationTypes} from '@/core/constants'
import PesquisaAvancada from '@/views/components/PesquisaAvancada.vue'
import PacienteFichaOrcamentoTabela
from '@/views/pages/cadastros/paciente/comum/orcamento/PacienteFichaOrcamentoTabela.vue'
import OrcamentoCadastro from '@/views/pages/cadastros/paciente/comum/orcamento/OrcamentoCadastro.vue'
import OrcamentoEdicao from '@/views/pages/cadastros/paciente/comum/orcamento/OrcamentoEdicao.vue'


export default {
    name: 'PacienteFichaOrcamento',
    components: {
        OrcamentoEdicao,
        OrcamentoCadastro,
        PacienteFichaOrcamentoTabela,
        PesquisaAvancada
    },
    data() {
        return {
            filtrosInterno: this.getFiltros(),
            paginacaoInterna: this.getPaginacao(),
            idPaciente: null,
            itens: [],
            paginas: 0,
            totalItens: 0,
            maxInputPesquisa: 30,
            linhasPorPagina: [10, 25, 50, 100],
            modoCadastro: false,
            modoEdicao: false,
            orcamentoSelecionado: null
        }
    },
    async mounted() {
        this.setarIdPaciente()
        await this.buscar()
    },
    methods: {
        setarIdPaciente() {
            if (this.$route.params.id) {
                this.idPaciente = this.$route.params.id
            }
        },
        async buscar() {
            this.$store.commit(mutationTypes.ORCAMENTO.SET_FILTROS_BUSCA_TODOS_ORCAMENTOS, this.filtrosInterno)
            await this.buscarOrcamentos()
        },
        async buscarOrcamentos() {
            const resposta = await this.$store.dispatch(actionTypes.ORCAMENTO.BUSCAR_TODOS_ORCAMENTOS, this.idPaciente)
            if (resposta) {
                this.itens = resposta.items
                this.paginas = resposta.totalPages
                this.totalItens = resposta.totalElements
            }
        },
        getFiltros() {
            const filtros = this.$store.state.orcamento.resultadoBuscaTodosOrcamentosFicha.filtros
            return _.cloneDeep(filtros)
        },
        getPaginacao() {
            return _.cloneDeep(this.$store.state.orcamento.resultadoBuscaTodosOrcamentosFicha.paginacao)
        },
        tratarEventoAcessarOrcamento(orcamento) {
            this.orcamentoSelecionado = orcamento
            this.modoCadastro = false
            this.modoEdicao = true
        },
        async fecharModalEdicaoCobranca() {
            this.orcamentoSelecionado = null
            await this.buscar()
        },
        async tratarEventoBuscaSimples(busca) {
            this.$store.commit(mutationTypes.ORCAMENTO.RESETA_PAGE)
            this.filtrosInterno.conteudo.value = busca
            await this.buscar()
        },
        async tratarEventoRemoverFiltro(propriedade) {
            if (this.filtrosInterno[propriedade]) {
                this.filtrosInterno[propriedade].value = this.filtrosInterno[propriedade].default
            }
            await this.buscar()
        },
        adicionarOrcamento() {
            this.modoCadastro = true
        },
        async cancelarModoCadastro() {
            this.modoCadastro = false
            await this.buscar()
        },
        async cancelarModoEdicao() {
            this.modoEdicao = false
            this.orcamentoSelecionado = null
            await this.buscar()
        },
        abrirModalRelatorioCobrancas() {
            this.modalRelatorioCobrancas = true
        },
        fecharModalRelatorioCobrancas() {
            this.modalRelatorioCobrancas = false
        },
        async resetarPaginacao() {
            this.$store.commit(mutationTypes.ORCAMENTO.RESETA_PAGE)
            await this.tratarEventoPaginar()
        },
        async tratarEventoPaginar() {
            this.$store.commit(mutationTypes.ORCAMENTO.SET_PAGINACAO_BUSCA_TODOS_ORCAMENTOS, this.paginacaoInterna)
            await this.buscar()
        },
    }
}
</script>

<style scoped lang="stylus">

.titulo
  font-size 15px
  font-weight bold
  color #777

.container-pesquisa-orcamentos
  display flex
  justify-content space-between
  align-items center
  padding 0 10px
  padding-top 2px

.container-tabela-orcamentos
  padding 0 24px 16px

</style>
